export default __webpack_public_path__ + "static/media/gl_3.98d88ac6.mp3";